export const common = {
  shell: {
    title: "VBS Jury",
    signOut: "Uitloggen",
    account: "Je account",
    signOutUnsynced_one:
      "Er staat nog 1 antwoord op dit apparaat dat niet is verstuurd. Als je afmeldt, gaat het verloren. Toch afmelden?",
    signOutUnsynced_other:
      "Er staan nog {{count}} antwoorden op dit apparaat die niet zijn verstuurd. Als je afmeldt, gaan ze verloren. Toch afmelden?",
    signOutOffline: "Je bent offline. Uitloggen kan alleen met verbinding.",
  },
  footer: {
    stichting: "Stichting Jeugdbrandweer Nederland",
    website: "VBS Jury",
  },
  version: {
    label: "Versie {{version}}",
    commit: "Commit {{commit}}",
  },
  theme: {
    label: "Weergave: {{theme}}",
    system: "automatisch",
    light: "licht",
    dark: "donker",
  },
  logoAlt: "Jeugdbrandweer Nederland",
  loading: "Bezig met laden…",
  actions: {
    busy: "Bezig…",
    cancel: "Annuleren",
    close: "Sluiten",
  },
  sidebar: {
    label: "Menu",
    description: "Ga naar een andere pagina.",
    toggle: "Menu openen of sluiten",
  },
  nav: {
    baanLabel: "{{datum}}, {{klasse}}",
    overzicht: "Baan",
    namens: "namens {{name}}",
  },
  sync: {
    unsynced_one: "1 antwoord nog niet verstuurd",
    unsynced_other: "{{count}} antwoorden nog niet verstuurd",
    allSynced: "Alles verstuurd",
    otherWaarnemer_one: "1 antwoord niet verstuurd, van een andere waarnemer",
    otherWaarnemer_other: "{{count}} antwoorden niet verstuurd, van een andere waarnemer",
    offline: "Offline",
    open: "Bekijk wat nog niet is verstuurd",
    title: "Versturen",
    description: "Een antwoord staat eerst op dit apparaat en gaat daarna naar de server.",
    now: "Nu versturen",
    empty: "Alles is verstuurd.",
    needsConnection: "Je bent offline. Versturen kan pas als je weer verbinding hebt.",
    list: "Nog niet verstuurd",
    baanUnknown: "Baan {{id}}",
    ploegUnknown: "Ploeg {{id}}",
    discard: {
      trigger: "Alles weggooien",
      title: "Niet verstuurde antwoorden weggooien?",
      description_one:
        "Dit antwoord staat alleen op dit apparaat. Als je het weggooit, komt het nooit op de server en is het niet meer terug te halen.",
      description_other:
        "Deze {{count}} antwoorden staan alleen op dit apparaat. Als je ze weggooit, komen ze nooit op de server en zijn ze niet meer terug te halen. Verstuurde antwoorden blijven staan.",
      confirm: "Ja, weggooien",
    },
    discardOne: {
      trigger: "Weggooien",
      label: "Gooi het antwoord op {{vraag}} bij {{ploeg}} weg",
      title: "Dit antwoord weggooien?",
      description:
        "Dit antwoord staat alleen op dit apparaat. Als je het weggooit, komt het nooit op de server en is het niet meer terug te halen.",
    },
  },
  table: {
    filters: {
      wissen: "Wissen",
      toepassen: "Toepassen",
      zoek: "Zoek een {{label}}",
      van: "{{label}} van",
      tot: "{{label}} tot en met",
      meer: "Nog {{count}} tonen",
      minder: "Minder tonen",
      aantalGekozen: "{{count}} gekozen",
    },
  },
  errors: {
    unexpected: "Er is iets misgegaan ({{status}}).",
    offline: "Je bent offline en dit staat nog niet op dit apparaat. Open het een keer met verbinding.",
  },
  notFound: {
    title: "Pagina niet gevonden",
    description: "Deze pagina bestaat niet. ",
    back: "Naar mijn banen",
  },
} as const;
